module.exports = __webpack_public_path__ + "img/speaker-03.2e915cb3.svg";